var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Button form",class:{
		primary: _vm.isPrimary,
		loading: _vm.settings.loading,
		disabled: !_vm.enabled,
	},on:{"click":_vm.onClick}},[(_vm.settings.loading)?_c('Icon',{staticClass:"spinner",attrs:{"icon":_vm.icons.Sync,"spin":""}}):_vm._e(),_c('div',{staticClass:"label"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.settings.text))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }